import React from "react";

const MAP = {
  pending: "bg-amber-100 text-amber-800 border-amber-200",
  approved: "bg-emerald-100 text-emerald-800 border-emerald-200",
  paid: "bg-green-100 text-green-800 border-green-300",
  rejected: "bg-rose-100 text-rose-800 border-rose-200",
  waiting: "bg-zinc-100 text-zinc-600 border-zinc-200",
};

export default function StatusBadge({ status, className = "", testId }) {
  const s = (status || "waiting").toLowerCase();
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize font-mono ${MAP[s] || MAP.waiting} ${className}`}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {s}
    </span>
  );
}
